var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "应用", prop: "appid", "label-width": "110px" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.formData.appid,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "appid", $$v)
                    },
                    expression: "formData.appid"
                  }
                },
                _vm._l(_vm.appListAllData, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.appid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: {
                label: "发货回调地址",
                prop: "callback_url",
                "label-width": "110px"
              }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入发货回调地址" },
                model: {
                  value: _vm.formData.callback_url,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "callback_url", $$v)
                  },
                  expression: "formData.callback_url"
                }
              })
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-form-item",
                { staticClass: "lodingItem" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.addContent()
                        }
                      }
                    },
                    [_vm._v("添加参数")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.formData.params, function(domain, index) {
            return _c("div", { key: index + "k", staticClass: "paramsClass" }, [
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      staticStyle: { "margin-right": "20px" },
                      attrs: {
                        prop: "params." + index + ".lable",
                        rules: _vm.rules.lable
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入键" },
                        model: {
                          value: domain.lable,
                          callback: function($$v) {
                            _vm.$set(domain, "lable", $$v)
                          },
                          expression: "domain.lable"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: {
                        prop: "params." + index + ".value",
                        rules: _vm.rules.value
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入值" },
                        model: {
                          value: domain.value,
                          callback: function($$v) {
                            _vm.$set(domain, "value", $$v)
                          },
                          expression: "domain.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-button", {
                    staticStyle: { margin: "0 10px 24px 10px" },
                    attrs: {
                      size: "mini",
                      type: "danger",
                      circle: "",
                      icon: "el-icon-delete"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.removeContent(domain)
                      }
                    }
                  })
                ],
                1
              )
            ])
          })
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "warning", round: "" },
              on: {
                click: function($event) {
                  return _vm.clearData(false)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit("ruleForm")
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }